import ReviewPosition from "PFApp/onboarding/parts/review_position";
import SectionBox from "PFComponents/box/section_box";
import Toggle from "PFComponents/toggle/toggle";
import PropTypes from "prop-types";
import React from "react";

const Position = ({ position, handleChangePosition, index, disabledItems, setDisabledItems, errors }) => {
  const isDisabled = disabledItems.positions[index];

  return (
    <SectionBox style={{ padding: 20, marginTop: 20 }} qaId={`ChangeRequest.Position.${position.ordinal}`}>
      <div style={{ textAlign: "right" }}>
        <Toggle
          checked={!isDisabled}
          onChange={(val) =>
            setDisabledItems((prev) => ({ ...prev, positions: { ...prev.positions, [index]: !val } }))
          }
        />
      </div>
      <div style={{ opacity: isDisabled ? 0.6 : 1, pointerEvents: isDisabled ? "none" : "initial" }}>
        <ReviewPosition
          errors={errors}
          position={position}
          style={{ marginBottom: 30 }}
          handleChange={handleChangePosition}
        />
      </div>
    </SectionBox>
  );
};

Position.propTypes = {
  position: PropTypes.shape({ ordinal: PropTypes.number }).isRequired,
  handleChangePosition: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
  disabledItems: PropTypes.object.isRequired,
  setDisabledItems: PropTypes.func.isRequired,

  errors: PropTypes.object
};

export default Position;
